<template>
    <div
        v-if="
            hasCustomerSpecificRules ||
            explanation ||
            period?.status === 'BEFORE_BOOKING_PERIOD' ||
            period?.status === 'AFTER_BOOKING_PERIOD'
        "
        class="flex items-start gap-2 text-sm text-gray-600"
    >
        <i
            class="pi pi-calendar mt-0.5 shrink-0 text-sm"
            aria-hidden="true"
        />
        <div class="min-w-0 space-y-1">
            <div v-if="period?.status === 'BEFORE_BOOKING_PERIOD'">
                {{ openingMessage(period) }}
            </div>
            <div v-else-if="period?.status === 'AFTER_BOOKING_PERIOD'">
                {{ t('purchaseContract.bookingClosed') }}
            </div>
            <template v-if="hasCustomerSpecificRules">
                <div
                    v-if="viewer"
                    :class="customerNoteClass"
                >
                    {{
                        t('purchaseContract.bookingForCustomer', {
                            name: `${viewer.firstName} ${viewer.lastName}`
                        })
                    }}
                </div>
                <i18n-t
                    v-else
                    :class="customerNoteClass"
                    keypath="purchaseContract.bookingSignInExplanation"
                    scope="global"
                    tag="p"
                >
                    <template #signIn>
                        <button
                            type="button"
                            class="text-primary-700 underline hover:text-primary-800"
                            @click="signIn"
                        >
                            {{ t('purchaseContract.bookingSignInToCheck') }}
                        </button>
                    </template>
                </i18n-t>
            </template>
            <div
                v-if="explanation"
                class="whitespace-pre-line"
            >
                {{ explanation }}
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import {
    useBookingPeriodMessage,
    type BookingPeriodData
} from './helpers/use-booking-period'
import { I18nT, useI18n } from 'vue-i18n'
import { useViewer, useShowLoginModal } from '~/composables/use-login'

defineProps<{
    hasCustomerSpecificRules: boolean
    customerNoteClass?: string
    explanation?: string
    period?: BookingPeriodData
}>()
const { t } = useI18n({ useScope: 'global' })
const viewer = useViewer()
const { openingMessage } = useBookingPeriodMessage()
const showLoginModal = useShowLoginModal()

async function signIn() {
    await showLoginModal({ showGuest: false })
}
</script>
